// Shared steak-mode logic extracted during Step 4.3.
//
// Both DailyOps.jsx and BusinessAnalytics.jsx clear the vors row's
// status and attach an explanatory label when the kitchen isn't
// serving vors (`no_vors` or `extra_steak` modes). The math is
// already zeroed via getDynamicCrossPoolAlloc — these helpers just
// return the human-facing label and the suppression predicate.

/** True when the steakMode means vors isn't served that day. */
export function isVorsSuppressed(steakMode) {
  return steakMode !== 'vors'
}

/** Returns the human-facing note for non-vors modes, or null when
 *  vors is served normally. */
export function vorsDisplayNote(steakMode) {
  if (steakMode === 'extra_steak') return 'Extra steak day — no vors served'
  if (steakMode === 'no_vors') return 'No vors today'
  return null
}
